import React, { FC } from "react";
import { InputAdornment, SxProps, TextField } from "@mui/material";
import SearchIcon from "../../assets/SearchIcon.svg";
import { searchFieldStyle } from "../../components/customerManagement/DisplayCustomers.styles";
import { sellerSearchFieldStyle } from "../../components/ledger/ledgerStyles";
import { useRole } from "../../context/RoleContext";

type SearchBarProps = {
  searchTerm: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const SearchBar: FC<SearchBarProps> = ({ searchTerm, handleSearch }) => {
  const { role } = useRole();

  const isSellerLedgerScreen =
    role === "maltora-seller" && location.pathname.includes("/ledgers");
  const mobileSearchFieldStyle: SxProps = isSellerLedgerScreen
    ? sellerSearchFieldStyle
    : {
        ...searchFieldStyle,
        width: { xs: "175px", sm: "200px" },
      };
  return (
    <TextField
      variant="outlined"
      placeholder="Search"
      value={searchTerm}
      size="small"
      onChange={handleSearch}
      sx={mobileSearchFieldStyle}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ marginLeft: "4px" }}>
            <img
              src={SearchIcon}
              width="24px"
              height="24px"
              style={{
                marginRight: 0,
              }}
              alt="Search"
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
